import { config } from './navigation-dots.settings';

const isDotsOverflow = (total: number, visibleDotLimit: number = config.visibleDotLimit): boolean =>
  total > visibleDotLimit;

const calculateSliderPosition = (
  activeIndex: number,
  total: number,
  dotSize: number = config.dotSize,
  visibleDotLimit: number = config.visibleDotLimit
): number => {
  const middleDotIndex = Math.ceil(visibleDotLimit / 2);

  if (activeIndex < middleDotIndex || !isDotsOverflow(total, visibleDotLimit)) {
    return 0;
  }

  const unitPerButton = dotSize * -1;

  if (activeIndex + middleDotIndex >= total) {
    return (total - middleDotIndex - (visibleDotLimit - middleDotIndex)) * unitPerButton;
  }

  return (activeIndex - (middleDotIndex - 1)) * unitPerButton;
};

const isFirstOrLastDot = (index: number, total: number): boolean => {
  const isFirstDot = index === 0;
  const isLastDot = index === total - 1;

  return isFirstDot || isLastDot;
};

const isDotTiny = (
  index: number,
  activeIndex: number,
  total: number,
  visibleDotLimit: number = config.visibleDotLimit
): boolean => {
  if (isFirstOrLastDot(index, total) || !isDotsOverflow(total, visibleDotLimit)) {
    return false;
  }

  const middleDotIndex = Math.ceil(visibleDotLimit / 2);

  const isLastDotStartSet = activeIndex < middleDotIndex && index === visibleDotLimit - 1;
  const isFirstDotEndSet = activeIndex + middleDotIndex >= total && index === total - visibleDotLimit;

  return isLastDotStartSet || isFirstDotEndSet;
};

const isDotSmall = (
  index: number,
  activeIndex: number,
  total: number,
  visibleDotLimit: number = config.visibleDotLimit
): boolean => {
  if (isFirstOrLastDot(index, total) || !isDotsOverflow(total, visibleDotLimit)) {
    return false;
  }

  const middleDotIndex = Math.ceil(visibleDotLimit / 2);

  const isSecondFirstDotEndSet = activeIndex + middleDotIndex >= total && index === total - visibleDotLimit + 1;
  const isSecondLastDotStartSet = activeIndex < middleDotIndex && index === visibleDotLimit - 2;

  const isLastDotMidSet = activeIndex >= middleDotIndex && index === activeIndex + (visibleDotLimit - middleDotIndex);
  const isFirstDotMidSet =
    activeIndex >= middleDotIndex &&
    activeIndex + middleDotIndex < total &&
    index === activeIndex - (visibleDotLimit - middleDotIndex);

  return isLastDotMidSet || isFirstDotMidSet || isSecondLastDotStartSet || isSecondFirstDotEndSet;
};

export { calculateSliderPosition, isDotTiny, isDotSmall, isFirstOrLastDot, isDotsOverflow };
